module.exports = __webpack_public_path__ + "source/img/volume-mute.5acc7531.svg";